import { Icon, PreIcon } from '@advanza/ui'
import clsx from 'clsx'
import { useDeleteModal } from 'hooks/modalHooks'
import { useProfileProjectsPhoto } from 'hooks/profileProjectsHooks'
import style from './profileProjectsPhotosEntity.module.css'

const ProfileProjectsPhotosEntity = ({ fileId, projectId }) => {
    const { entity, getImgStyle, onDelete } = useProfileProjectsPhoto(fileId, projectId)
    const { openModal: openDeleteModal, modal: deleteModal } = useDeleteModal(
        entity._saving,
        onDelete,
        'photo',
    )

    const renderPhoto = () => {
        const hasError = entity && entity._errors && entity._errors.error
        return (
            <div className={clsx(style.bgImg, hasError && style.withError)} style={getImgStyle()}>
                <div className={clsx(style.editBtn, style.flexCenter)} onClick={openDeleteModal}>
                    <Icon fontSize={14} name="clear" white />
                </div>
                {hasError && (
                    <div className={style.errorMsg}>
                        <PreIcon name="error" fontSize={22} red>
                            <span>{entity._errors.error}</span>
                        </PreIcon>
                    </div>
                )}
            </div>
        )
    }

    return (
        <>
            {renderPhoto()}
            {deleteModal}
        </>
    )
}

export default ProfileProjectsPhotosEntity
